//@flow
import React, { Component } from 'react';
import AutoComplete from './autocomplete';
import Loader from './loader';
import InputAdornment from './Adornment';
import {
  fetchAddress
} from './fetch';
import { FormControlLabel, Checkbox } from '@material-ui/core';
import { Grid, Cell } from 'react-flexr';

function sanitizeUnit(unit) {
  const {
    id,
    href,
    adressebetegnelse: address,
    dør: door,
    etage: floor,
    adgangsadresse: {
      adgangspunkt: { koordinater: coordinates },
      postnummer: { navn: city, nr: zip },
      vejstykke: { navn: street },
      husnr: house
    }
  } = unit;
  coordinates.reverse();
  return {
    id,
    href,
    address,
    street,
    house,
    floor,
    door,
    zip,
    city,
    geo: { coordinates }
  };
}

export default class AutoCompleteDAWA extends Component {
  constructor(props) {
    super(props);
    this.state = {
      anonymous: props.anonymous || false
    };
  }

  handleAnonymousChange = (ev) => {
    this.setState({ anonymous: ev.target.checked }, () => {
      this.props.onAnonymousSelect('LOCATION');
    });
  };

  getSuggestions = (searchText) => {
    return searchText.length > 2 ? fetchAddress(searchText) : [];
  };

  handleSelect = (
    event,
    { suggestion /*, suggestionValue, suggestionIndex, sectionIndex, method*/ }
  ) => {
    if (!suggestion || typeof suggestion !== 'object' || !suggestion.value) {
      this._selected = { suggestion };
      return this.props.onSelect(suggestion, null);
    }

    this._selected = { suggestion, pending: true };

    fetch(suggestion.value)
      .then((response) => response.json())
      .then((data) => sanitizeUnit(data))
      .then((data) => {
        this._selected = { suggestion, data };
        this.props.onSelect(suggestion, data);
      });
  };

  render() {
    return (
      <>
        {this.props.headline ? (
          <Grid
            style={{
              fontSize: '1.4em',
              lineHeight: '1em',
              whiteSpace: 'nowrap',
              marginBottom: 11,
              display: 'flex',
              justifyContent: 'flex-start',
              alignItems: 'center'
            }}
          >
            {this.props.loader ? <Loader /> : null}
            <Cell key={this.props.headline}>{this.props.headline}</Cell>
          </Grid>
        ) : null}
        <AutoComplete
          reset={this.props.reset}
          defaultValue={this.props.defaultValue}
          getSuggestions={this.getSuggestions}
          onSuggestionSelected={this.handleSelect}
          focusInputOnSuggestionClick={false}
          error={this.props.error}
          inputProps={{
            onBlur: this.props.onBlur,
            disabled: this.props.locked,
            required: true,
            'data-cy': 'address',
            placeholder: this.props.placeholder,
            label: this.props.label,
            style: {
              marginBottom: 24,
              ...(this.props.style || {}),
              zIndex: 1
            },
            InputLabelProps: { shrink: true },
            startAdornment: (
              <InputAdornment
                icon={
                  this.state.anonymous ? 'LocationOffOutlined' : 'PlaceOutlined'
                }
              />
            ),
            helperText: this.props.onAnonymousSelect && (
              <FormControlLabel
                style={{ marginLeft: '-5px' }}
                control={
                  <Checkbox
                    style={{ padding: '6px' }}
                    color="primary"
                    checked={this.state.anonymous}
                    name="anonymous"
                    onClick={this.handleAnonymousChange}
                  />
                }
                label={'Skjul den fulde adresse i annoncen'}
              />
            )
          }}
        />
      </>
    );
  }
}
